import { FormBuilder, Validators } from '@angular/forms';
import { MatSort, MatPaginator } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { isBefore, isDate } from 'date-fns';
import { DataTableSource } from '../../classes/DataTableSource/datatablesource';
import { ApplicationService } from '../../services/application/application.service';
import { AuthService } from '../../services/authentication/auth.service';
import { DialogService } from '../../services/dialogs/dialogs.service';
import { DownloadService } from '../../services/download/download.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService } from '../../services/user/user.service';
import { DateFnsPipe } from '../../pipes/datefns.pipe';
import { TitleCasePipe } from '../../pipes/titlecase.pipe';
var IssueReportReviewComponent = /** @class */ (function () {
    function IssueReportReviewComponent(appService, authService, dateFNSPipe, dialogService, downloadService, errorService, fb, mediaChange, splashService, titleCasePipe, userService) {
        this.appService = appService;
        this.authService = authService;
        this.dateFNSPipe = dateFNSPipe;
        this.dialogService = dialogService;
        this.downloadService = downloadService;
        this.errorService = errorService;
        this.fb = fb;
        this.mediaChange = mediaChange;
        this.splashService = splashService;
        this.titleCasePipe = titleCasePipe;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllHeaders = ['IssueNumber', 'DateReported', 'ReporterName', 'Issue', 'Status', 'ResolverName', 'Actions'];
        this.AvailableIssuesAllHeaders = ['IssueID', 'DisplayText', 'RequiresDescription', 'InUse', 'SortOrder', 'Actions'];
    }
    IssueReportReviewComponent.prototype.ngOnInit = function () {
        var self = this;
        self.AvailableIssues = null;
        self.AvailableIssuesData = new DataTableSource([]);
        self.FilteredIssuesList = null;
        self.IssueDisplayMode = 'U';
        self.IssuesData = new DataTableSource([], self.paginator, self.sorter, self.SortIssues.bind(self));
        self.IssuesList = null;
        self.NoData = false;
        self.NoIssuesData = false;
        self.ViewReady = false;
        self.ShowingNewUserForm = false;
        self.SmallDisplay = false;
        self.User = null;
        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
            self.AvailableIssuesVisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AvailableIssuesAllHeaders.slice();
            self.AvailableIssuesVisibleColumns = self.NoIssuesData ? ['NoData'] : self.AvailableIssuesVisibleHeaders.slice();
        });
        // Get the first non-null UserInfo object so we can begin setting up the component
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (user) { return user && !!user.AuthToken; })).subscribe(function (user) {
            self.User = user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load the issues in the database and the issue reports
            var issuereports = self.appService.GetAllIssueReports(self.User.AuthToken, self.User.CurrentRole);
            var issues = self.appService.GetAllWebAppIssues();
            combineLatest(issues, issuereports, function (_issues, reports) {
                return {
                    Issues: _issues,
                    Reports: reports,
                };
            })
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (packet) {
                self.UpdateAvailableIssues(packet.Issues);
                self.UpdateIssues(packet.Reports);
                // Make the form for creating new issue types
                self.NewIssueTypeForm = self.fb.group({
                    DisplayText: [null, Validators.required],
                    RequiresDescription: [false],
                });
                // Ready for component use.
                self.ViewReady = true;
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    IssueReportReviewComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    // #region Add New Issue Type Method
    IssueReportReviewComponent.prototype.AddNewIssueType = function () {
        var self = this;
        var form = self.NewIssueTypeForm.value;
        // Get confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to add the following new issue type:<br /><br />" +
                ("<strong>Display Text: </strong>" + form.DisplayText + "<br />") +
                ("<strong>Requires Description: </strong>" + (form.RequiresDescription ? 'Yes' : 'No') + "<br /><br />") +
                "Once added, the new issue type will become available upon a user's next login to the " +
                "DELTA System. Are you sure you wish to add this issue type?",
            OKText: 'Yes - Add',
            CancelText: 'No - Cancel',
        })
            .subscribe(function (result) {
            if (result === true) {
                // User is proceeding. Add the new issue type.
                self.appService
                    .AddWebAppIssueType(self.User.AuthToken, self.User.CurrentRole, form.DisplayText, form.RequiresDescription)
                    .subscribe(function (issues) {
                    // Update the types known.
                    self.UpdateAvailableIssues(issues);
                    // Clear the new issue type form.
                    self.NewIssueTypeForm.reset();
                    // Snackbar success
                    self.splashService.SnackbarSuccess('Issue Type Added Successfully.');
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Move Issue Downward Method
    IssueReportReviewComponent.prototype.MoveIssueDownward = function (issue) {
        var self = this;
        if (!issue) {
            return;
        }
        var sortOrder = issue.SortOrder || 0;
        self.appService.UpdateWebAppIssueSortOrder(self.User.AuthToken, self.User.CurrentRole, issue.IssueID, sortOrder + 1).subscribe(function (issues) {
            // Update the types known.
            self.UpdateAvailableIssues(issues);
            // Snackbar success
            self.splashService.SnackbarSuccess('Issue Type Moved Down Successfully.');
        }, function (error) {
            self.errorService.HandleServiceError(error);
        });
    };
    // #endregion
    // #region Move Issue Upward Method
    IssueReportReviewComponent.prototype.MoveIssueUpward = function (issue) {
        var self = this;
        if (!issue) {
            return;
        }
        var sortOrder = issue.SortOrder || 0;
        self.appService.UpdateWebAppIssueSortOrder(self.User.AuthToken, self.User.CurrentRole, issue.IssueID, sortOrder - 1).subscribe(function (issues) {
            // Update the types known.
            self.UpdateAvailableIssues(issues);
            // Snackbar success
            self.splashService.SnackbarSuccess('Issue Type Moved Up Successfully.');
        }, function (error) {
            self.errorService.HandleServiceError(error);
        });
    };
    // #endregion
    // #region Remove Issue Type Method
    IssueReportReviewComponent.prototype.RemoveIssueType = function (issue) {
        var self = this;
        if (!issue) {
            return;
        }
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to remove the following issue type from the Issue Reporting " +
                ("Tool for the DELTA System:<br /><br /><strong>Issue ID #: </strong>" + issue.IssueID + "<br />") +
                ("<strong>Display Text: </strong>" + issue.DisplayText + "<br /><strong>Requires Description: </strong>") +
                ((issue.RequiresDescription ? 'Yes' : 'No') + "<br /><br />Once removed, this issue type will ") +
                "no longer be available for use in the Issue Reporting Tool. Are you sure you wish to continue?",
            OKText: 'Yes - Remove',
            CancelText: 'No - Cancel',
        })
            .subscribe(function (result) {
            if (result === true) {
                // Remove the issue type
                self.appService.RemoveWebAppIssueType(self.User.AuthToken, self.User.CurrentRole, issue.IssueID).subscribe(function (issues) {
                    // Update the types known.
                    self.UpdateAvailableIssues(issues);
                    // Snackbar success
                    self.splashService.SnackbarSuccess('Issue Type Removed Successfully.');
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Resolve Issue Method
    IssueReportReviewComponent.prototype.ResolveIssue = function (issue) {
        var self = this;
        if (!issue || issue.Resolved) {
            return;
        }
        var issueType = self.AvailableIssues.find(function (item) { return item.IssueID === issue.IssueID; });
        var message = "You have chosen to resolve the following issue report:<br /><br />\n        <strong>Issue #: </strong>" + issue.WebAppIssueReportID + "<br />\n        <strong>Issue: </strong>" + ((issueType && issueType.DisplayText) || 'Other') + "<br />\n        <strong>Issue Description: </strong>" + issue.IssueDescription + "<br /><br />\n        Please provide a note in the space provided below that describes the resolution. Are you sure you wish to continue?";
        // Get a confirmation
        self.dialogService
            .OpenTextNoteDialog({ TitleText: 'Resolve Issue', MessageText: message, OKText: 'OK - Resolve', CancelText: 'Cancel' })
            .subscribe(function (result) {
            if (result != null) {
                // User has opted to proceed. Signal the system to resolve this issue.
                self.appService
                    .ResolveIssueReport(self.User.AuthToken, self.User.CurrentRole, issue.WebAppIssueReportID, result)
                    .subscribe(function (issues) {
                    // Completed. Refresh the list of issues from what was just returned.
                    self.UpdateIssues(issues);
                    // Toast the success
                    self.splashService.SnackbarSuccess("Issue #" + issue.WebAppIssueReportID + " Resolved Successfully.");
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Sort Issues Method
    IssueReportReviewComponent.prototype.SortIssues = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'IssueNumber':
                _a = [First.WebAppIssueReportID, Second.WebAppIssueReportID], PropA = _a[0], PropB = _a[1];
                break;
            case 'DateReported':
                _b = [First.DateReported, Second.DateReported], PropA = _b[0], PropB = _b[1];
                break;
            case 'ReporterName':
                _c = [
                    First.ReportedByLastName + ", " + First.ReportedByFirstName,
                    Second.ReportedByLastName + ", " + Second.ReportedByFirstName,
                ], PropA = _c[0], PropB = _c[1];
                break;
            case 'Issue':
                _d = [First.IssueName, Second.IssueName], PropA = _d[0], PropB = _d[1];
                break;
            case 'Status':
                _e = [First.Resolved ? 'Yes' : 'No', Second.Resolved ? 'Yes' : 'No'], PropA = _e[0], PropB = _e[1];
                break;
            case 'ResolverName':
                _f = [
                    First.ResolvedByLastName + ", " + First.ResolvedByFirstName,
                    Second.ResolvedByLastName + ", " + Second.ResolvedByFirstName,
                ], PropA = _f[0], PropB = _f[1];
                break;
        }
        if (isDate(PropA) || isDate(PropB)) {
            var baseSort = 0;
            if (isDate(PropA) && !isDate(PropB)) {
                baseSort = 1;
            }
            else if (isDate(PropB) && !isDate(PropA)) {
                baseSort = -1;
            }
            else if (isBefore(PropA, PropB)) {
                baseSort = -1;
            }
            else if (isBefore(PropB, PropA)) {
                baseSort = 1;
            }
            return baseSort * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        else {
            var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
            var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
            return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        var _a, _b, _c, _d, _e, _f;
    };
    // #endregion
    // #region Update Available Issues Method
    IssueReportReviewComponent.prototype.UpdateAvailableIssues = function (issues) {
        var self = this;
        self.AvailableIssues = issues;
        if (!self.AvailableIssues || !self.AvailableIssues.length) {
            self.NoIssuesData = true;
            self.AvailableIssuesData.Update([{}]);
        }
        else {
            self.NoIssuesData = false;
            self.AvailableIssuesData.Update(self.AvailableIssues);
        }
        self.AvailableIssuesVisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AvailableIssuesAllHeaders.slice();
        self.AvailableIssuesVisibleColumns = self.NoIssuesData ? ['NoData'] : self.AvailableIssuesVisibleHeaders.slice();
    };
    // #endregion
    // #region Update Issue Display Mode Method
    IssueReportReviewComponent.prototype.UpdateIssueDisplayMode = function (event) {
        var self = this;
        if (!event || !event.value) {
            return;
        }
        // Update the issues by triggering the filtering
        self.UpdateIssues(self.IssuesList);
    };
    // #endregion
    // #region Update Issues Method
    IssueReportReviewComponent.prototype.UpdateIssues = function (issues) {
        var self = this;
        self.IssuesList = issues;
        // Apply filtering.
        self.FilteredIssuesList = (self.IssuesList || []).filter(function (item) {
            return (self.IssueDisplayMode === 'A' ||
                (self.IssueDisplayMode === 'U' && item.Resolved !== true) ||
                (self.IssueDisplayMode === 'R' && item.Resolved === true));
        });
        if (!self.FilteredIssuesList || !self.FilteredIssuesList.length) {
            self.NoData = true;
            // Put in a fake record to trip the display message
            self.IssuesData.Update([{}]);
        }
        else {
            self.NoData = false;
            self.IssuesData.Update(self.FilteredIssuesList);
        }
        self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
        self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
    };
    // #endregion
    // #region View Issue Report Detail Method
    IssueReportReviewComponent.prototype.ViewIssueReportDetail = function (issue) {
        var self = this;
        var message = "<strong>Issue #: </strong>" + issue.WebAppIssueReportID + "<br />\n        <strong>Reported On: </strong>" + self.dateFNSPipe.transform(issue.DateReported, 'M/D/YYYY h:mm A') + "<br />\n        <strong>Reported By: </strong>" + issue.ReportedByFirstName + " " + issue.ReportedByLastName + "<br />\n        <strong>Reporter Email: </strong>" + (issue.ReporterEmail || 'Not Provided') + "<br />\n        <strong>Reporter SAPID: </strong>" + (issue.ReportedBySAPID || 'N/A') + "<br />\n        <strong>Reporter Student ID: </strong>" + (issue.ReportedByStudentID || 'N/A') + "<br /><br />\n        <strong>Issue: </strong>" + issue.IssueName + "<br />\n        <strong>Description: </strong>" + (issue.IssueDescription || 'Not Provided') + "<br /><br />";
        if (issue.Resolved) {
            message += "<strong>Resolved On: </strong>" + self.dateFNSPipe.transform(issue.ResolvedDate, 'M/D/YYYY h:mm A') + "<br />\n            <strong>Resolved By: </strong>" + issue.ResolvedByFirstName + " " + issue.ResolvedByLastName + "<br />\n            <strong>Resolver SAPID: </strong>" + issue.ResolvedBySAPID;
        }
        self.dialogService
            .OpenMessageBoxDialog({ TitleText: "Issue #" + issue.WebAppIssueReportID + " Details", MessageText: message, OKText: 'OK' })
            .subscribe();
    };
    return IssueReportReviewComponent;
}());
export { IssueReportReviewComponent };
// #region Custom Classes
// #endregion



// WEBPACK FOOTER //
// ./src/app/issuereportreview/issuereportreview.component.ts.pre-build-optimizer.js